import React from 'react'

const IndependentLogisticsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <g fillRule="evenodd" clipRule="evenodd">
                        <path
                            fill="#29b2db"
                            d="m183.164 242.096 1.354 188.239H5.998v-33.833l5.777-11.319v-45.891l36.296-97.196z"
                            opacity={1}
                            data-original="#29b2db"
                            className=""
                        />
                        <path
                            fill="#0d92ba"
                            d="m6.367 395.887 5.408-10.704v-6.027h6.896c4.552 0 8.367 3.691 8.367 8.363 0 4.555-3.815 8.368-8.367 8.368z"
                            opacity={1}
                            data-original="#0d92ba"
                        />
                        <path
                            fill="#ca200a"
                            d="M168.895 182.548h301.918v247.787H168.895z"
                            opacity={1}
                            data-original="#ca200a"
                            className="hovered-path"
                        />
                        <path
                            fill="#424242"
                            d="M383.826 468.599c20.797 0 37.652-16.854 37.652-37.648 0-20.667-16.855-37.646-37.652-37.646-20.664 0-37.646 16.979-37.646 37.646 0 20.793 16.982 37.648 37.646 37.648zM87.322 468.599c20.791 0 37.646-16.854 37.646-37.648 0-20.667-16.855-37.646-37.646-37.646-20.672 0-37.647 16.979-37.647 37.646 0 20.793 16.975 37.648 37.647 37.648z"
                            opacity={1}
                            data-original="#424242"
                        />
                        <path
                            fill="#bbecff"
                            d="m72.93 275.81-22.149 56.839h84.52V275.81z"
                            opacity={1}
                            data-original="#bbecff"
                            className=""
                        />
                        <path
                            fill="#29b2db"
                            d="m430.951 88.43 19.687-19.811 30.14 30.145-19.807 19.684c8.361 12.303 14.271 26.207 17.102 41.339h27.93v42.569h-27.93c-2.831 15.011-8.74 29.037-17.102 41.217l19.807 19.807-30.14 30.021-19.687-19.688a113.728 113.728 0 0 1-41.338 17.104v27.928H347.04v-27.928c-15.007-2.956-29.034-8.858-41.216-17.104l-19.805 19.688L256 263.38l19.683-19.807c-8.24-12.181-14.146-26.206-17.1-41.217h-27.929v-42.569h27.929c2.953-15.132 8.859-29.037 17.1-41.339L256 98.764l30.02-30.144 19.805 19.811c12.182-8.368 26.209-14.273 41.216-17.101V43.401h42.573v27.928a109.544 109.544 0 0 1 41.337 17.101z"
                            opacity={1}
                            data-original="#29b2db"
                            className=""
                        />
                        <path
                            fill="#bbecff"
                            d="M368.326 249.848c37.892 0 68.774-30.882 68.774-68.776 0-37.892-30.883-68.775-68.774-68.775-37.893 0-68.771 30.883-68.771 68.775 0 37.894 30.879 68.776 68.771 68.776z"
                            opacity={1}
                            data-original="#bbecff"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default IndependentLogisticsIcon